import run from '../../utilities/run';
import $ from 'jquery';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
//import { createPreventDefault } from '../../utilities/general';
//import { setElementsFromScope } from '../../utilities/selectorHelpers';
import addressValidationFactory from '../common/AddressValidation.js';
import { setOptionsForSelect, setElementsFromScope, hide, show } from "../../utilities/selectorHelpers";

var enableUserEnteredAddressRadioForSPL =true;
var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
console.log('we should get this page');
const _ = require("underscore");
const targetSelector = "#selfOnboard-retailer-wizard";
const addressElementsMap = {
  country: '.ret-country',
  address1: '.ret-address1',
  address2: '.ret-address2',
  city: '.ret-city',
  state: '.ret-state',
  zipCode: '.ret-zip-code',
  postalCodeLabel:'#postalcode-label',
  stateLabel:'#state-label',
  county: '.ret-county',
  countyMandatoryLabel: '.county-mandatory-label',
  stateSelectContainer: '.state-wrapper',
  stateTextContainer: '.state-text-wrapper',
  stateTextInput: '.ret-state-text',
  commercialAddressFlag: '.commercial-addr-flag'
  
};
// Modal Html to use
require("./returnsTechnologyRegistration.less")

run(targetSelector, (el)=>{
  attachStubExample(el);
});

function attachStubExample(el) {
  const mainHtml = render(
    require("./html/initial-registartion.html"), {
  }
  );
  
  const mainEl = $(mainHtml);
  const entryEl = $("<div class='entry-point'></div>");
  $(el).html(entryEl);
  entryEl.append(mainEl);

const countries = el.data('countries');
const defaultCountry = el.data('default-country'); 
const usaStates = el.data('usa-states'); 
const caProvinces = el.data('ca-provinces'); 
const countryPhoneCodeList = el.data('country-phone-code-list');
const UsercountryPhoneCodeList = el.data('country-phone-code-list');
const facilityTypes = el.data('facility-types');
const validationReqdCountries = el.data('validation-reqd-countries');
const addressValidationFor = el.data('address-validation-for');
const prefixes = el.data('prefixes');
const addressValidationUrl = el.data('address-validation-url');
const generalErrorMessage = el.data('general-error-message');
const addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
const addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
const redirectWelcomePageUrl = el.data('Redirect-Welcome-PageUrl');
const checkUserNameValidation = el.data('check-user-name-url');
const checkRetailerNameValidation = el.data('check-retailer-name-exist-url');
const registarionSubmitUrl = el.data('registration-submit-url');
const submitUrl = el.data('submit-url');
const namespace = el.data('namespace');
//const submitModalFlow = new SubmitModalFlow();
//const initialRegistrationPage = e1.data("initial-registration-page-url");

let retailer = {};



//form validation
const validator = $(".initialRegistrationForm").validate({
  errorPlacement: function(error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
});

validator.settings.ignore = ":disabled,:hidden";



$(countries).each(function(){
  var option = $('<option />');
  option.attr('value', this.conCode).text(this.conName);
  //option.attr('value', this.cdmValue).text(this.cdmMeaning);
  $('#selfMerchantCountry').append(option);
});

$('#selfMerchantCountry').change(function(){
  var countryVal = $('#selfMerchantCountry option:selected').val();
  setStates(countryVal);
});

function setStates(countryVal) {
  $('#selfMerchantState').html('');
  var option = $('<option />');
  option.attr('value', "-1").text('Select State/Province/Region');
  option.attr('selected','selected');
  option.attr('disabled','disabled');
  let checkZipCode = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
          if(this.conPostalCodeRequired.toString() === "Y"){
            checkZipCode=true;
          }
      }
    });
  if(countryVal == "US" && checkZipCode) {
    $('#selfMerchantStateContainer').css("display", "block");
    $('#stateTextContainer').css("display", "none");
    $('#stateText').prop('required',false);
    $('#selfMerchantState').prop('required',true);
    $('#selfMerchantState').append(option);
    $(usaStates).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
    
      $('#selfMerchantState').append(option);
    });
  } else if(countryVal == "CA" && checkZipCode) {
    $('#selfMerchantStateContainer').css("display", "block");
    $('#stateTextContainer').css("display", "none");
    $('#stateText').prop('required',false);
    $('#selfMerchantState').prop('required',true);
    $('#selfMerchantState').append(option);
    $(caProvinces).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      $('#selfMerchantState').append(option);
    });
  } else{
    $('#stateText').prop('required',false);
    $('#selfMerchantState').prop('required',false);
   $('#selfMerchantStateContainer').css("display", "none");
   $('#stateTextContainer').css("display", "block");
  }
}

 /* $(el).html(entryEl);
  entryEl.append(mainEl);*/

  let els = {

  };
  let elsMap = {
    submitBtn:'.submit-account-btn'
  };
  
 $(countryPhoneCodeList).each(function(){
    var option = $('<option />');
    option.attr('value', this.conPhoneCode).text(this.conCode);
    $('#selfMerchantPhoneCode').append(option);
  });
  
 $(countryPhoneCodeList).each(function(){
    var option = $('<option />');
    option.attr('value', this.conPhoneCode).text(this.conCode);
    $('#selfUserCountryCode').append(option);
  });
  let done;
  const addressValidationModalEl = $("#add-validation-model");
  $('.submit-account-btn').click(function(){
    //event.preventDefault();
    var requiredFields  = $('input, select').filter('[required]:visible');
    var allRequired =true;
    
    requiredFields.each(function(){
    $("#requriedFieldError").each(function(){
      $(this).remove();
  });
});
    requiredFields.each(function(){
        if($(this).val() == ''){
          //event.preventDefault();
          
          allRequired=false;
          var error = '<label id="requriedFieldError" class="help-block" style="color: #b50303;">The field is required !!</label>';
          $(this).after(error);
         // $('form').unbind('submit').submit();
        }
    }); 
    if(allRequired){
    const addressValidationForSelfRegistrationTab = addressValidationFactory(null, el, {
      isAlreadyValid: false,
      currentTab: ".Self-Registration-Tab",
      disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
      disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
    });
    console.log("address value" +JSON.stringify(addressValidationForSelfRegistrationTab.determineAddressValidity(done))); 
  }
  });

  $("#initail-reg-modal-cancel").click(function(){
    $("#confirmationBox").modal("hide");
  });
  $("#initail-reg-modal-continue").click(function(){
    processSubmitButton();
    $("#confirmationBox").modal("hide");
  });

  $(".ret-MerchantName").change(function(){
    $('#merchant-name-exist-error').css('display','none');
    var selfMerchantName = $("#selfMerchantName").val();
    validateRetailerName(selfMerchantName);
  });

  function validateRetailerName(selfMerchantName) {
    $.ajax(
      {
        url: checkRetailerNameValidation,
        type: "GET",
        data: { inputValue: selfMerchantName},
        
        success: function (data) {            
          if (data.trim() == 'true') {
              $('.submit-account-btn').attr('disabled','disabled');
              $('#merchant-name-exist-error').css('display','inline-block');
       
          } else {
            $('.submit-account-btn').removeAttr('disabled');
          } 
        }
      });
  }
  $(".ret-MerchantUrl").change(function(){
    $('#merchant-invalid-error').css('display','none');
    var selfMerchantUrl = $("#selfMerchantUrl").val();
    var isvalidUrl = validateURL(selfMerchantUrl);
    if(!isvalidUrl){
      $('#merchant-invalid-error').css('display','inline-block');
    }
  });

  function validateURL(selfMerchantUrl) {
    var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return urlregex.test(selfMerchantUrl);
}

  $(".screenName").change(function(){
    $('#user-exist-error').css('display','none');
    //elsPage.userNameExistError.hide();
    //elsPage.userNameValidationError.hide();
    var inputValue = $("#selfUserId").val();
    checkDuplicateUserDetails('UserName', inputValue);
});

$(".emailAddress").change(function(){
    $('#user-email-exist-error').css('display','none');
    //elsPage.userNameExistError.hide();
    //elsPage.userNameValidationError.hide();
    var inputValue = $("#selfUserEmail").val();
    checkDuplicateUserDetails('EmailId', inputValue);
 
});

   //Check duplicate user name
   var checkDuplicateUserDetails = function (inputType, inputValue) {
    if(inputType == 'UserName'){
      var pattern = /^[0-9a-zA-Z]+$/;
      if(!inputValue.match(pattern) && !inputValue == '') {
       // elsPage.userNameValidationError.show();
       $('.submit-account-btn').attr('disabled','disabled');
       $('#user-exist-error').css('display','inline-block');
      }
    }else if(inputType == 'EmailId'){

    }

    if (inputType.length > 0 && inputValue.length > 0) {
      $.ajax(
        {
          url: checkUserNameValidation,
          type: "GET",
          data: { inputValue: inputValue, inputType: inputType },
          beforeSend: function () {
           // $.blockUI({ message: 'Checking User Name, Please Wait..' });
          },
          complete: function () {
            //$.unblockUI();
          },
          success: function (data) {            
            if (data.trim() == 'true') {
              if (inputType == 'UserName') {
                $('.submit-account-btn').attr('disabled','disabled');
                $('#user-exist-error').css('display','inline-block');
                
              } else if (inputType == 'EmailId') {
                $('.submit-account-btn').attr('disabled','disabled');
                $('#user-email-exist-error').css('display','inline-block');
               
              } else{
                console.log("dont know what is valid");
              }

            } else {
              $('.submit-account-btn').removeAttr('disabled');

              //if (elsPage.userNameExistError.is(":visible") || elsPage.userEmailExistError.is(":visible") || elsPage.userNameValidationError.is(":visible")) {
                console.log("username Invalid");
              //}else{
              //  console.log("dont know what is Invalid");
              //}
            } 
          }
        });
    }
  }

   /*els.submitBtn.on("click", function(e){
    processSubmitButton();
  });*/

  function countryChange() {
    let countryVal = $('#selfMerchantCountry').find('option:selected').val();
    let isValidCountry = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
        countryId = this.conPhoneCode.toString();
        return false;
      } 
    });
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryVal.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country-not-supported-primary").hide();        
    }else{
      $(".country-not-supported-primary").show();
    }
    setStates(countryVal);
    if(countryVal === "US"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States of America +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "CA"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "Canada +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "UM"){
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States Minor Outlying Islands +1";
    }).prop("selected", true).trigger("change");
    }else{
      $(".ret-office-country-code option").filter(function() {
        let text= $(this).val().toString();
        return text === countryId.toString();
    }).prop("selected", true).trigger("change");
    }
    if(countryVal === "US" || countryVal === "CA" ){
      show(els.officeAreaCode);
      els.officePhone.attr("placeholder", "___-____");
      els.officePhone.addClass('ret-phone-number-jqv');
      els.officePhone.removeClass('phoneNonUS');
      addmasks();
    }else {
      els.officeAreaCode.val('');
      if(els.officeAreaCode){
        hide(els.officeAreaCode);
      }
      els.officePhone.val('');
      els.officePhone.addClass('phoneNonUS');
      els.officePhone.removeClass('ret-phone-number-jqv');
      els.officePhone.removeAttr('placeholder'); 
      els.officePhone.inputmask({
        mask: ""
      }); 
    }
  }
  
  function createRetailerJson(){
    //create retailer JSON
    retailer.rtlType = "C";
    retailer.rtlStatus = "A";
    retailer.enrollmentConfigs = {
        enrollments:"RMS"
      };
    retailer.rtlName = $("#selfMerchantName").val();
    retailer.rtlWebUrl = $("#selfMerchantUrl").val();
    retailer.rtlContactFirstName= $("#selfMerchantContactFirstName").val();
    retailer.rtlContactLastName= $("#selfMerchantContactLastName").val();
  
    retailer.rtlEmail= $("#selfMerchantEmail").val();
    retailer.rtlAddress1 = $("#selfMerchantAddress1").val();
    retailer.rtlAddress2 = $("#selfMerchantAddress2").val();
    retailer.rtlCity = $("#selfMerchantCity").val();
    if($("#selfMerchantCountry").val() == 'US' || $("#selfMerchantCountry").val() == 'CA'){
        retailer.rtlState = $("#selfMerchantState").val();
      }else{
        retailer.rtlState = $("#stateText").val();
      }
    retailer.rtlConCode = $("#selfMerchantCountry").val();
    retailer.rtlZip = $("#selfMerchantZip").val();
    retailer.rtlOfficePhoneCountryCode = $("#selfMerchantPhoneCode").val();
    retailer.rtlOfficePhone =  $("#selfMerchantPhone").val();
    retailer.userFirstName= $("#selfUserFirstName").val();
    retailer.userLastName= $("#selfUserLastName").val();
    retailer.userOrgTitle= $("#selfUserOrgTitle").val();
    retailer.userPhoneCountryCode = $("#selfUserCountryCode").val();
    retailer.userPhone =  $("#selfUserPhone").val();
    retailer.userEmail= $("#selfUserEmail").val();
    retailer.userId= $("#selfUserId").val();
  }

  var submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
  //submitModalFlow.showLoadingModal(); 

  const initialRegistrationPage = $("#selfOnboard-retailer-wizard").data("initial-registration-page-url");
  function processSubmitButton() {
    console.log("inside submit controller button function");
    AUI().use('liferay-portlet-url', function(A) {
       createRetailerJson();
        $.ajax({
          url: registarionSubmitUrl,
          data: {
            '_merchantselfonboarding_WAR_retailerportlet_retailerJson': JSON.stringify(retailer)
          },
          dataType:"JSON",
          type: 'POST',
          cache: false,
          success: function(response) {
            console.log("submit function sucess")
            submitModalFlow.showSuccessModal();
            setTimeout(function () { submitModalFlow.hideAllModals(); }, 100);
            location.reload(true);
            let myUrl =  "/c/portal/logout";  
            window.open(myUrl, '_self', '');
          },     
          error: function(){
           submitModalFlow.hideAllModals();
           submitModalFlow.showFailureModal();
  
          }
      });
    });
}

};



// WEBPACK FOOTER //
// ./src/pages/rmaMerchantSelfOnboarding/rmaSelfRegistarionForm.js